var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphonesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icone vantagem 03",
    clipPath: "url(#clip0_56_810)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7794 35.4939C15.7794 37.9786 17.8008 40 20.2855 40H29.9695C33.542 40 36.4619 37.1588 36.5924 33.6175C38.6878 33.6038 40.3886 31.8954 40.3886 29.7962V21.8549C40.3886 19.758 38.6916 18.0511 36.5985 18.0336H33.6199C31.5275 18.0504 29.8298 19.758 29.8298 21.8542V29.7954C29.8298 31.8893 31.5222 33.5939 33.6107 33.616C33.484 35.5145 31.8993 37.0206 29.9695 37.0206H26.2893C26.4619 36.5435 26.5558 36.029 26.5558 35.4931C26.5558 33.0084 24.5344 30.987 22.0496 30.987H20.2848C17.8008 30.987 15.7794 33.0084 15.7794 35.4931V35.4939ZM32.8084 29.7962V21.8549C32.8084 21.3901 33.1871 21.0114 33.6519 21.0114H36.5672C37.0321 21.0114 37.4107 21.3901 37.4107 21.8549V29.7962C37.4107 30.261 37.0321 30.6397 36.5672 30.6397H33.6519C33.1871 30.6397 32.8084 30.261 32.8084 29.7962ZM20.2848 33.9664H22.0496C22.8916 33.9664 23.5771 34.6519 23.5771 35.4939C23.5771 36.3359 22.8916 37.0214 22.0496 37.0214H20.2848C19.4428 37.0214 18.7573 36.3359 18.7573 35.4939C18.7573 34.6519 19.4428 33.9664 20.2848 33.9664Z",
    fill: "#CC092F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.79008 18.0336C1.69771 18.0504 0 19.758 0 21.8549V29.7962C0 31.9038 1.7145 33.6175 3.82137 33.6175H6.73664C8.84427 33.6175 10.558 31.903 10.558 29.7962V21.8549C10.558 19.758 8.86107 18.0511 6.76794 18.0336H3.79008ZM7.58015 21.8549V29.7962C7.58015 30.261 7.20153 30.6397 6.73664 30.6397H3.82137C3.35649 30.6397 2.97786 30.261 2.97786 29.7962V21.8549C2.97786 21.3901 3.35649 21.0114 3.82137 21.0114H6.73664C7.20153 21.0114 7.58015 21.3901 7.58015 21.8549Z",
    fill: "#CC092F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.8199 18.2038H33.842C33.842 9.8084 27.7893 2.97786 20.3496 2.97786C12.9099 2.97786 6.85726 9.8084 6.85726 18.2038H3.87939C3.87939 8.16641 11.2679 0 20.3496 0C29.4313 0 36.8199 8.16641 36.8199 18.2038Z",
    fill: "#CC092F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3885,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesIcon);
export default __webpack_public_path__ + "static/media/headphones-icon.ca8b279189766f23741f68dd23e1fc22.svg";
export { ForwardRef as ReactComponent };